"use client";

import Script from "next/script";

import { logError } from "@/services/DatadogService/DatadogService";

interface AmplitudeWebExperimentsProps {
  amplitudeApiKey: string;
}

export const AmplitudeWebExperiments = ({ amplitudeApiKey }: AmplitudeWebExperimentsProps) => (
  <Script
    id="amplitude-web-experiment"
    crossOrigin="anonymous"
    strategy="lazyOnload" //puede generar flickering en testAB, en ese caso se puede cambiara a afterInteractive
    src={`https://cdn.eu.amplitude.com/script/${amplitudeApiKey}.experiment.js`}
    onError={(e) => {
      logError(new Error("Amplitude Web Experiments script failed to load"), {
        context: "AmplitudeWebExperiments",
        details: e,
      });
    }}
  />
);
